export type {};

declare global {
  interface RegExpConstructor {
    escape: (value: string) => string;
  }
}

if (!RegExp.escape) {
  Object.defineProperty(RegExp, 'escape', {
    enumerable: false,
    writable: false,
    value: function (string: string): string {
      return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'); // $& means the whole matched string
    }
  });
}
